import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import logoImage from "../assets/Frame 1000005895.png";
import upgradeButtonImage from "../assets/Frame 9.png";
import projectsButtonImage from "../assets/Frame 5.png";
import languageButtonImage from "../assets/Frame 1000005885 (1).png";
import profileButtonImage from "../assets/Frame 2 (1).png";
import LanguageModal from "../components/LanguageModal";
import ProfileMenu from "../components/ProfileMenu";

const UpgradePage = () => {
  const navigate = useNavigate();
  const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState({
    name: "English",
    code: "en-IN",
    flag: "🇮🇳",
  });
  const [showPopup, setShowPopup] = useState(false);

  const goToProjects = () => {
    navigate("/projects");
  };

  const openLanguageModal = () => {
    setIsLanguageModalOpen(true);
  };

  const closeLanguageModal = () => {
    setIsLanguageModalOpen(false);
  };

  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  const closeProfileMenu = () => {
    setIsProfileMenuOpen(false);
  };

  const handleLanguageChange = (language) => {
    setCurrentLanguage(language);
    // You can add code here to change the language in your app
    console.log(`Language changed to: ${language.name} (${language.code})`);
  };

  const handleUpgradeClick = () => {
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
    }, 3000);
  };

  return (
    <PageContainer>
      <Header>
        <Logo src={logoImage} alt="Total AI" onClick={() => navigate("/")} />
        <HeaderControls>
          <UpgradeButton>
            <UpgradeButtonImg src={upgradeButtonImage} alt="Upgrade" />
          </UpgradeButton>
          <ProjectsButton onClick={goToProjects}>
            <ProjectsButtonImg src={projectsButtonImage} alt="My Projects" />
          </ProjectsButton>

          <ProfileButton onClick={toggleProfileMenu}>
            <ProfileButtonImg src={profileButtonImage} alt="Profile" />
          </ProfileButton>
        </HeaderControls>
      </Header>

      <MainContent>
        <PlanHeader>My Plan</PlanHeader>

        <PlansContainer>
          <PlanCard basic>
            <PlanType>For Hobby</PlanType>
            <PlanPrice>Free</PlanPrice>

            <PlanButton currentPlan>Current Plan</PlanButton>
            <PlanFeatures>
              <PlanFeatureTitle>For hobby projects</PlanFeatureTitle>
              <PlanFeature>Up to 20 prompts per week</PlanFeature>
              <PlanFeature>Unlimited remixing</PlanFeature>
              <PlanFeature>Play any user-created game</PlanFeature>
              <PlanFeature>
                Limited Asset Generation (for non-commercial use)
              </PlanFeature>
              <PlanFeature>Up to 50 AI Character chats per week</PlanFeature>
              <PlanFeature>
                Limited number of projects. Old projects can be deleted.
              </PlanFeature>
            </PlanFeatures>
          </PlanCard>

          <PlanCard>
            <PlanType>For Learners</PlanType>
            <PlanPrice>AED 30/month</PlanPrice>

            <PlanButton onClick={handleUpgradeClick}>Upgrade Now</PlanButton>
            <PlanFeatures>
              <PlanFeatureTitle>For hobby projects</PlanFeatureTitle>
              <PlanFeature>Up to 300 prompts per month</PlanFeature>
              <PlanFeature>Unlimited remixing</PlanFeature>
              <PlanFeature>Play any user-created game</PlanFeature>
              <PlanFeature>
                Limited Asset Generation (for non-commercial use)
              </PlanFeature>
              <PlanFeature>Disable remixing on published projects</PlanFeature>
              <PlanFeature>Limited AI Character chats</PlanFeature>
            </PlanFeatures>
          </PlanCard>

          <PlanCard special>
            <SpecialBadge>For Developers</SpecialBadge>
            <PlanPrice>AED 90/month</PlanPrice>

            <PlanButton onClick={handleUpgradeClick}>Upgrade Now</PlanButton>
            <PlanFeatures>
              <PlanFeatureTitle>For hobby projects</PlanFeatureTitle>
              <PlanFeature>Deploy custom site </PlanFeature>
              <PlanFeature>Unlimited prompts per month</PlanFeature>
              <PlanFeature>Unlimited remixing</PlanFeature>
              <PlanFeature>Play any user-created game</PlanFeature>
              <PlanFeature>
                Unlimited Asset Generation (with commercial usage rights)
              </PlanFeature>
              <PlanFeature>Disable remixing on published projects</PlanFeature>
              <PlanFeature>Limited AI Character chats</PlanFeature>
              <PlanFeature>
                Commercial rights to use code generated in games
              </PlanFeature>
            </PlanFeatures>
          </PlanCard>

          <PlanCard pro>
            <PlanType>For Business</PlanType>
            <PlanPrice>AED 150/month</PlanPrice>

            <PlanButton proPlan onClick={handleUpgradeClick}>
              Upgrade Now
            </PlanButton>
            <PlanFeatures>
              <PlanFeatureTitle>For hobby projects</PlanFeatureTitle>
              <PlanFeature>
                Deploy custom site (more pages than 10x Dev)
              </PlanFeature>
              <PlanFeature>
                Unlimited prompts per month (more premium prompts)
              </PlanFeature>
              <PlanFeature>Unlimited remixing</PlanFeature>
              <PlanFeature>Play any user-created game</PlanFeature>
              <PlanFeature>
                Unlimited Asset Generation (with commercial usage rights)
              </PlanFeature>
              <PlanFeature>Unlimited AI Character chats</PlanFeature>
              <PlanFeature>
                Commercial rights to use code generated in games
              </PlanFeature>
              <PlanFeature>Disable remixing on published projects</PlanFeature>
              <PlanFeature>Download your code</PlanFeature>
            </PlanFeatures>
          </PlanCard>
        </PlansContainer>
      </MainContent>

      {showPopup && (
        <PopupMessage>
          This feature is not functional right now in your region, Please visit
          later.
        </PopupMessage>
      )}

      <LanguageModal
        isOpen={isLanguageModalOpen}
        onClose={closeLanguageModal}
        onLanguageChange={handleLanguageChange}
      />

      <ProfileMenu isOpen={isProfileMenuOpen} onClose={closeProfileMenu} />
    </PageContainer>
  );
};

// Styled Components
const PageContainer = styled.div`
  font-family: "Space Grotesk", sans-serif;
  max-width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #eaeaea;
`;

const Logo = styled.img`
  height: 24px;
`;

const HeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const UpgradeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
`;

const UpgradeButtonImg = styled.img`
  height: 36px;
  width: auto;
`;

const ProjectsButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
`;

const ProjectsButtonImg = styled.img`
  height: 36px;
  width: auto;
`;

const LanguageButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
`;

const ButtonImage = styled.img`
  height: 36px;
  width: auto;
`;

const LanguageText = styled.span`
  margin-left: 8px;
  font-size: 14px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const ProfileButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
`;

const ProfileButtonImg = styled.img`
  height: 36px;
  width: auto;
`;

const MainContent = styled.main`
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 0;
  overflow: hidden;
`;

const PlanHeader = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: #111;
  margin-bottom: 32px;
  padding: 0 24px;
`;

const PlansContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  padding: 0;
  margin: 0;
  width: 100%;
`;

const PlanCard = styled.div`
  border-radius: 16px;
  overflow: hidden;
  background: ${(props) => (props.pro ? "#111" : "white")};
  color: ${(props) => (props.pro ? "white" : "#333")};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
  width: 100%;
  border: 1px solid
    ${(props) =>
      props.basic
        ? "#eaeaea"
        : props.pro
        ? "#333"
        : props.special
        ? "#f5dcc8"
        : "#eaeaea"};
  padding: 24px;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  }
`;

const PlanType = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
`;

const SpecialBadge = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
`;

const PlanPrice = styled.h2`
  font-size: 25px;
  font-weight: 700;
  margin: 8px 0;
`;

const BillingCycle = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
`;

const PlanButton = styled.button`
  width: 100%;
  padding: 12px;
  text-align: center;
  border-radius: 10px;
  font-weight: 600;
  margin-bottom: 24px;
  cursor: pointer;
  transition: background-color 0.2s;

  ${(props) =>
    props.currentPlan &&
    `
    background: transparent;
    border: 1px solid #ccc;
    color: #333;
    
  `}

  ${(props) =>
    !props.currentPlan &&
    !props.proPlan &&
    `
    background: transparent;
    color: #E80694;
    border: 1px solid #E8069433;
    &:hover {
      opacity: 0.9;
    }
  `}
  
  ${(props) =>
    props.proPlan &&
    `
    
    color: #E80694;
    border: 1px solid #E8069433;
    background: transparent;
    &:hover {
      opacity: 0.9;
    }
  `}
`;

const PlanFeatures = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const PlanFeatureTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px;
`;

const PlanFeature = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  line-height: 1.5;

  &:before {
    content: "✓";
    margin-right: 8px;
    color: ${(props) => (props.theme.pro ? "#0782FE" : "#5B68DF")};
    font-weight: bold;
  }
`;

const PopupMessage = styled.div`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  z-index: 1000;
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translate(-50%, 20px);
    }
    to {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }
`;

export default UpgradePage;
